import { useState, useEffect, useCallback, useRef } from 'react';

const useCountdownTimer = (second, isPaused, { onTimeout } = {}) => {
  const [timeLeft, setTimeLeft] = useState(second);
  const intervalRef = useRef();
  const setTimeLeftCallback = useCallback((updateTime) => {
    setTimeLeft(updateTime);
  }, []);

  const onTimeoutCallback = useCallback(() => {
    typeof onTimeout === 'function' && onTimeout();
    clearInterval(intervalRef.current);
  }, []);
  useEffect(() => {
    if (!isPaused && timeLeft > 0) {
      const updateTime = timeLeft - 1;
      const id = setInterval(() => {
        setTimeLeftCallback(updateTime);
      }, 1000);
      intervalRef.current = id;
    }
    if (timeLeft === 0) {
      onTimeoutCallback();
    }
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [isPaused, onTimeoutCallback, setTimeLeftCallback, timeLeft]);

  return [timeLeft, setTimeLeftCallback];
};

export default useCountdownTimer;
